import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HeaderService } from '../header.service';
import RoutesserviceService from '../routesservice.service';

@Injectable({
  providedIn: 'root',
})
export class EvaluationService {
  constructor(
    private httpClient: HttpClient,
    private Customeroutes: RoutesserviceService,
    private HeaderService: HeaderService
  ) { }

  async getEvaluation() {

    //alert('inpolicy');
    return this.httpClient
      .post(this.Customeroutes.getEmployeeEvaluations(), '', {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          //if login is true the store it into local storage
          // localStorage.setItem('token', data.data.token);
          return data;
        }
        return data;
      });
  }



  async getEvaluationAdmin(role: any) {
    const formdata = {
      user_role: role,
    };
    //alert('inpolicy');
    return this.httpClient
      .post(this.Customeroutes.getEmployeeEvaluations(), formdata, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          //if login is true the store it into local storage
          // localStorage.setItem('token', data.data.token);
          return data;
        }
        return data;
      });
  }


  async getAllEvaluationsDetails(month: any, day: any, year: any) {
    const formdata = {
      month: month,
      year: year,
      day: day,
    };
    return this.httpClient
      .post(this.Customeroutes.getAllEvaluationsDetails(), formdata, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          //if login is true the store it into local storage
          // localStorage.setItem('token', data.data.token);
          return data;
        }
        return data;
      });
  }

  async getAllEvaluationsFilters(month: any, start: any, end: any) {
    const formdata = {
      month: month,
      start_date: start,
      end_date: end,
    };
    return this.httpClient
      .post(this.Customeroutes.getAllEvaluationsFilter(), formdata, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          //if login is true the store it into local storage
          // localStorage.setItem('token', data.data.token);
          return data;
        }
        return data;
      });
  }

  async getAllEvaluationsCountByMonth(month: any, year: any) {
    const formdata = {
      month: month,
      year: year,
    };
    return this.httpClient
      .post(this.Customeroutes.getEvaluationCountByMonth(), formdata, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          //if login is true the store it into local storage
          // localStorage.setItem('token', data.data.token);
          return data;
        }
        return data;
      });
  }

  async getKPVList(user_id: string) {
    const formdata = {
      user_id: user_id
    };
    return this.httpClient
      .post(this.Customeroutes.getKPVList(), formdata, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          //if login is true the store it into local storage
          // localStorage.setItem('token', data.data.token);
          return data;
        }
        return data;
      });
  }

  async addOrUpdateKPV(model: any) {
    return this.httpClient
      .post(this.Customeroutes.addOrUpdateKPV(), model, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          //if login is true the store it into local storage
          // localStorage.setItem('token', data.data.token);
          return data;
        }
        return data;
      });
  }

  async getAllUsersEvaluationAdmin(model: any) {
    return this.httpClient
      .post(this.Customeroutes.getAllUsersEvaluationAdmin(), model, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          //if login is true the store it into local storage
          // localStorage.setItem('token', data.data.token);
          return data;
        }
        return data;
      });
  }


  async getAllUsersEvaluationteam(department: any): Promise<any> {
    try {
      if (!department.month_char) {
        const Teamdepartment = {
          department: department
        };

        return await this.httpClient.post(
          this.Customeroutes.AllUsersEvaluationteam(),
          Teamdepartment,
          {
            headers: this.HeaderService.getHeaderWithToken(
              localStorage.getItem('token')
            ),
          }
        ).toPromise();
      } else {
        return await this.httpClient.post(
          this.Customeroutes.AllUsersEvaluationteam(),
          department,
          {
            headers: this.HeaderService.getHeaderWithToken(
              localStorage.getItem('token')
            ),
          }
        ).toPromise();
      }
    } catch (error) {
      console.error("Error occurred:", error);
      throw error;
    }
  }




  async getUserEvaluation(id: any) {
    const user_id = {
      user_id: id,
    };
    return this.httpClient
      .post(this.Customeroutes.getUseranualEvaluation(), user_id, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {

        if (data.success == true) {
          //if login is true the store it into local storage
          // localStorage.setItem('token', data.data.token);
          return data;
        }
        return data;
      });
  }


  async getevaluationedid(id: any) {
    const ev_id = {
      id: id,
    };
    return this.httpClient
      .post(this.Customeroutes.getEvaluation(), ev_id, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {

        if (data.success == true) {
          //if login is true the store it into local storage
          // localStorage.setItem('token', data.data.token);
          return data;
        }
        return data;
      });
  }


  async published(publish: any) {

    const is_publish = {
      is_evaluation: publish,
    };
    return this.httpClient
      .post(this.Customeroutes.publish(), is_publish, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {

        if (data.success == true) {
          //if login is true the store it into local storage
          // localStorage.setItem('token', data.data.token);
          return data;
        }
        return data;
      });
  }



  async getAllUsers(selectedTab: any, date: any) {
    const is_publish = {
      user_role: selectedTab,
      date: date
    };
    return this.httpClient
      .post(this.Customeroutes.getAllUsers(), is_publish, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.status == "success") {
          return data;
        }
        return data;
      });
  }



  async addBulkEvaluation(submissionData: any) {
    const is_publish = {
      evaluations: submissionData,
    };
    return this.httpClient
      .post(this.Customeroutes.addBulkEvaluation(), is_publish, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          return data;
        }
        return data;
      });
  }
}
